<template>
    <div>
        <wrapper>
            <div class="loading_container" v-if="loading">
                <pre-loader></pre-loader>
            </div>
            <fragment v-else>
            <table class="class_description" >
                <tr>
                    <td>Class</td><td>{{ data.name }}</td>
                </tr>
                <tr>
                    <td>Course</td><td>{{ data.course.name }}</td>
                </tr>
            </table>
            <subject-display></subject-display>
            <div class="row">
                <div class="col m6">
                
                </div>
            </div>
            
            </fragment>
        </wrapper>
    </div>
</template>
<script>
import SubjectDisplay from '@/components/ClassView/SubjectDisplay/SubjectDisplay.vue';
export default {
    mounted()
    {
        this.$store.dispatch("get_class",{id:this.$route.params.id});
    },
    components:{
        "subject-display":SubjectDisplay,
    },
    computed: 
    {
      data()
      {
          return this.$store.getters.each_class;
      },
      loading()
      {
          return this.$store.getters.class_loading;
      }

    }
}
</script>
<style lang="scss">
    .class_description
    {
        margin-left:20%;
        width:60%;
        margin-top:20px;
    }
    

    .description_box 
    {
        position: absolute;
        bottom:30px;
        right:15%;
        width:70%;
    }

</style>